import useChatClientChannels from './useChatClientChannels';

export default useChatClientChannels;
